module.exports = __webpack_public_path__ + "img/logo_blue_2.5f1d6358.png";